"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unregisterShortcut = exports.registerShortcut = exports.getSelectedText = void 0;
/**
 * Gets selected text by synthesizing the keyboard shortcut
 * "CommandOrControl+c" then reading text from the clipboard
 */
const getSelectedText = () => window.todesktop.selectedText.getSelectedText();
exports.getSelectedText = getSelectedText;
/**
 * Registers a global shortcut of `accelerator`. The `callback` is called
 * with the selected text when the registered shorcut is pressed by the user
 *
 * Returns `true` if the shortcut was registered successfully
 */
const registerShortcut = (...args) => window.todesktop.selectedText.registerShortcut(...args);
exports.registerShortcut = registerShortcut;
/**
 * Unregisters a global shortcut of `accelerator` and
 * is equivalent to electron.globalShortcut.unregister
 */
const unregisterShortcut = (...args) => window.todesktop.selectedText.unregisterShortcut(...args);
exports.unregisterShortcut = unregisterShortcut;
